import InquiryApi from '@apis/inquiry/InquiryApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useCloseInquiry(inquiryId: string) {
    const { t } = useTranslation('inquiry');
    const toast = useToast();
    const queryClient = useQueryClient();
    const { pop } = useFlow();
    const { mutate } = useMutation({
        mutationFn: () => InquiryApi.closeInquiry(inquiryId),
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: queries.inquiry._def });
            toast.success(t('closeModal.success'));
            pop();
        },
        onError(e: AxiosError) {
            console.error(e);
            toast.error(t('closeModal.error'));
        },
    });
    return () => mutate();
}

export default useCloseInquiry;
